import React from 'react';
import Masonry from 'react-masonry-css';
import Pin from './Pin';
import {motion} from 'framer-motion'

const breakpointColumnsObj = {
  default: 4,
  3000: 6,
  2000: 5,
  1200: 3,
  1000: 2,
  500: 1,
};

const MasonryLayout = ({ pins }) => (
  <motion.div
   whileInView={{ opacity: [0, 1] }}
  transition={{ duration:0.5, type: 'tween' }}
  >
    <Masonry className="flex animate-slide-fwd  dark:bg-slate-800" breakpointCols={breakpointColumnsObj}>
    {pins?.map((pin) => <Pin key={pin._id} pin={pin} className="w-max " />)}
  </Masonry>
  </motion.div>
);

export default MasonryLayout;